/* Sky Kids Modern: colour preview dots on the Color option buttons */
(function () {
  if (window.__smSwatch) return; window.__smSwatch = true;
  var C = {
    'teal & lime': 'linear-gradient(135deg,#1b8a8f 50%,#c8f31d 50%)',
    'brown & beige': 'linear-gradient(135deg,#6a4a3a 50%,#dcc8a4 50%)',
    'hot pink': '#e8318a',
    'navy & sky blue': 'linear-gradient(135deg,#1c2b5c 50%,#8fd3f0 50%)',
    'coral red': '#e8604c',
    'mint green': '#a9ddc9',
    'blush pink': '#f2b5bc',
    'baby pink': '#f7b6c9',
    'royal blue': '#2257b8',
    'mint & silver': 'linear-gradient(135deg,#a7dcc0 50%,#c9ced3 50%)',
    'lilac & silver': 'linear-gradient(135deg,#b9a2e0 50%,#c9ced3 50%)',
    'forest green': '#1f4a3d',
    'dusty pink': '#e5a99a',
    'sand beige': '#d9c3a3',
    'khaki brown': '#8a7656',
    'tan brown': '#b36b2f',
    'black': '#141414',
    'taupe brown': '#8b7a68',
    'tan': '#c98f4f',
    'chocolate brown': '#5a3a28'
  };
  function apply() {
    document.querySelectorAll('label.variant-option__button-label').forEach(function (lb) {
      if (lb.querySelector('.sm-dot') || lb.querySelector('.swatch')) return; /* real swatches replace the old dots */
      var inp = lb.querySelector('input');
      if (!inp || inp.getAttribute('data-option-name') !== 'Color') return;
      var bg = C[(inp.value || '').toLowerCase()];
      if (!bg) return;
      var d = document.createElement('span'); d.className = 'sm-dot'; d.style.background = bg; d.setAttribute('aria-hidden', 'true');
      lb.insertBefore(d, lb.querySelector('.variant-option__button-label__text') || null);
      lb.classList.add('sm-has-dot');
    });
  }
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(apply, 30); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', apply); } else { apply(); }
})();
